// extracted by mini-css-extract-plugin
module.exports = {"backToTop":"BackToTop_backToTop_2VhzK"};